
class GenericError {
    message = '';
    
    setAndLogMessage = (message) => {
        this.message = message;
        console.log(message);
    }
}

export default GenericError;
